{
  "ingestionSettings": {
    "defaultStandards": {
      "description": "Choose the default standards for your organization",
      "title": "Default standards"
    },
    "description": "Configure the ingestion settings for your organization",
    "title": "Ingestion settings",
    "traceabilityMethod": {
      "description": "Choose the method in how you want to trace your products",
      "options": {
        "default": {
          "description": "Default traceability method which traces products individually based on a unicity of reference, colour and collection",
          "title": "Default"
        },
        "multisourcing": {
          "description": "Trace your products based on a unicity of suppliers",
          "title": "Traceability by Multisourcing"
        },
        "traceabilityByPo": {
          "description": "Traces product based on a unicity of PO",
          "title": "Traceability by PO"
        }
      },
      "title": "Traceability method"
    },
    "update": {
      "error": "An error occurred while updating the ingestion settings",
      "success": "Ingestion settings updated successfully"
    }
  },
  "inviteUsers": {
    "error": "Error inviting users",
    "success": "Users invited successfully"
  },
  "mapping": {
    "create": "Create",
    "mapping": "Mapping",
    "material": "Material",
    "pageDescription": "This page allows you to configure your product types to our product types",
    "pending_one": "1 product type is not mapped with ours",
    "pending_other": "{{count}} of your products types are not mapped with ours",
    "product": "Product",
    "search": "Search",
    "standards": "Standards",
    "success": "All your products types have been mapped with ours",
    "title": "Mapping"
  },
  "supplierSettings": {
    "addNewSupplier": "Add new business partner",
    "addSupplier": "Save",
    "cancel": "Cancel",
    "deleteSupplier": {
      "cancel": "Cancel",
      "confirm": "Delete",
      "error": "Error deleting business partner",
      "message": "Are you sure you want to delete the selected business partner? This action is irrevocable",
      "success": {
        "message": "Business partner deleted successfully",
        "title": "Business partner deleted"
      },
      "title": "Confirmation"
    },
    "dropdownButton": {
      "label": "Actions"
    },
    "importSuppliers": "Import business partners",
    "invalidEmail": "Invalid email",
    "productionSites": {
      "noProductionSitesLabel": "None",
      "productionOperations": "Production operations",
      "title": "Associated production sites"
    },
    "searchSuppliers": "Search suppliers",
    "submit": "Submit",
    "supplierEmail": "Supplier email",
    "title": "Business Partner"
  }
}
